module.exports = __webpack_public_path__ + "static/scale-model-of-sedgwick-county-zoo-in-wichita-kansas-30ede66a8e75602ea0fe9c1e5239fe60.png";